import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeRowStyles } from './styles';
import { context as GutterContext, gutterStyle } from './useGutter';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    style = _this$get.style,
    justify = _this$get.justify,
    align = _this$get.align;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-row"] = true, _classNameObj[k + "-justify-" + justify] = justify, _classNameObj[k + "-align-" + align] = align, _classNameObj[className] = className, _classNameObj[makeRowStyles(k)] = true, _classNameObj);
  var gutter = this.gutter.getGutter();
  var newStyle = gutter ? gutterStyle(gutter, style, 'margin') : style;
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this), {
    'style': newStyle
  }), _$cc(GutterContext.Provider, {
    'value': gutter,
    'children': children
  }));
}
;